export enum WorkflowStepType {
  LightUpdate = 'lightupdate'
}
